module.exports = __webpack_public_path__ + "img/conf_webex.3e0e9f1d.png";